import React from 'react';
import { variants } from './style';

export const SkillContext = React.createContext<{
  variant: keyof typeof variants;
  disabled?: boolean;
}>({
  variant: 'default',
  disabled: false,
});

export function SkillContextProvider({
  disabled,
  variant,
  children,
}: {
  variant: keyof typeof variants;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return <SkillContext value={{ disabled, variant }}>{children}</SkillContext>;
}

export function useSkillContext() {
  const context = React.use(SkillContext);

  if (!context) {
    throw new Error('This component must be used as a child of Skill component');
  }
  return context;
}
